import * as React from "react";
import styles = require("./style.less");
import { MeasureScrollableTableProps, MeasureScrollableTableState } from "./MeasureScrollableTable";
import MeasureScrollableTable from "./MeasureScrollableTable";

interface ScrollableTableState {
    afterMeasured?: MeasureScrollableTableProps & MeasureScrollableTableState;
    beforeMeasured?: MeasureScrollableTableProps;
}

export default class ScrollableTable extends React.Component<MeasureScrollableTableProps, ScrollableTableState> {

    constructor(props: MeasureScrollableTableProps) {
        super(props);

        this.state = {
            beforeMeasured: props
        };
    }

    componentWillReceiveProps(newProps: MeasureScrollableTableProps) {
        this.setState({beforeMeasured: newProps});
    }

    render() {
        return <div>
            {this.state.afterMeasured && <div>
                <MeasureScrollableTable
                    measurements={this.state.afterMeasured}
                    {...this.state.afterMeasured}
                    onWindowResized={this.handleChanges}
                />
            </div>}
            {this.state.beforeMeasured && <div style={{visibility: "hidden"}}><MeasureScrollableTable
                {...this.state.beforeMeasured}
                onMeasured={this.handleChanges}
            /></div>}
        </div>;
    }

    private handleChanges = (s: MeasureScrollableTableState) => {
        this.setState(prev => ({
            beforeMeasured: undefined,
            afterMeasured: {
                ...prev.beforeMeasured,
                ...s
            }}));
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/projects/components/ProjectDashboard/ScrollableTable.tsx